import React, { useEffect, useState } from "react";
import { api, money } from "@/lib/api";
import { TriangleAlert, FilePlus2, Scale } from "lucide-react";

export default function Variance() {
  const [v, setV] = useState(null);
  const [deposits, setDeposits] = useState([]);
  useEffect(() => {
    api.get("/reports/variance").then(({ data }) => setV(data));
    api.get("/deposits").then(({ data }) => setDeposits(data));
  }, []);

  return (
    <div className="space-y-6">
      <div><h1 className="font-serif text-4xl">Variance &amp; Deposits</h1><p className="text-[color:var(--ink-2)]">Amendments, cash mismatches, and reconciliation gaps.</p></div>

      <div className="card p-6">
        <h3 className="font-semibold mb-4 flex items-center gap-2"><Scale size={16} /> Deposit Log &amp; Reconciliation</h3>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="text-[color:var(--muted)] text-left"><tr><th className="p-2">Date</th><th className="p-2">Campus</th><th className="p-2">Bag</th><th className="p-2 text-right">Counted</th><th className="p-2 text-right">Bank Posted</th><th className="p-2 text-right">Variance</th></tr></thead>
            <tbody>
              {deposits.map((d) => {
                const rec = d.reconciliation || {};
                return (
                  <tr key={d.session_id} className="border-t border-[color:var(--line)]" data-testid={`deposit-${d.session_id}`}>
                    <td className="p-2">{d.date}</td><td className="p-2">{d.campus}</td>
                    <td className="p-2 font-mono text-xs">{d.bag_serial}</td>
                    <td className="p-2 text-right font-mono tabnum">{money(d.grand_total)}</td>
                    <td className="p-2 text-right font-mono tabnum">{rec.bank_posted_amount != null ? money(rec.bank_posted_amount) : "—"}</td>
                    <td className={`p-2 text-right font-mono tabnum ${rec.variance_flag ? "text-[color:var(--terracotta)] font-semibold" : ""}`}>{rec.variance != null ? money(rec.variance) : "—"}</td>
                  </tr>
                );
              })}
              {deposits.length === 0 && <tr><td colSpan={6} className="p-6 text-center text-[color:var(--muted)]">No locked deposits.</td></tr>}
            </tbody>
          </table>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="card p-6">
          <h3 className="font-semibold mb-3 flex items-center gap-2"><TriangleAlert size={16} className="text-[color:var(--terracotta)]" /> Cash Mismatch Events</h3>
          {(v?.cash_mismatches || []).length === 0 && <p className="text-sm text-[color:var(--muted)]">None recorded.</p>}
          <div className="space-y-2">
            {(v?.cash_mismatches || []).map((m, i) => (
              <div key={i} className="text-sm p-3 rounded-lg bg-[color:var(--terracotta-light)]">
                <div className="font-medium">Attempt {m.details?.attempt} · {m.details?.denominations?.join(", ")}</div>
                <div className="text-xs text-[color:var(--muted)]">{String(m.timestamp).slice(0, 19)} · session {String(m.entity_id).slice(0, 8)}</div>
              </div>
            ))}
          </div>
        </div>
        <div className="card p-6">
          <h3 className="font-semibold mb-3 flex items-center gap-2"><FilePlus2 size={16} /> Amendments</h3>
          {(v?.amendments || []).length === 0 && <p className="text-sm text-[color:var(--muted)]">None filed.</p>}
          <div className="space-y-2">
            {(v?.amendments || []).map((a) => (
              <div key={a.id} className="text-sm p-3 rounded-lg bg-[color:var(--cream)]">
                <div className="font-medium">{a.reason}</div>
                <div className="text-xs text-[color:var(--muted)]">{a.admin_email} · {String(a.timestamp).slice(0, 19)}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
